module.exports = __webpack_public_path__ + "img/SAFo_KeyTakeAways_Mobile.9a5106b9.svg";